import React from "react";
import * as styles from "./velavu-modal-container.module.scss";
import { classArr } from "../helper/style-helper";

export interface VelavuModalContainerProps {
	style?: React.CSSProperties;
	className?: string;
	children?: React.ReactNode;
}

/**
 * A white sheet background container for modal content
 */
export default function VelavuModalContainer(props: VelavuModalContainerProps) {
	return (
		<div
			style={props.style}
			className={classArr(styles.container, props.className)}
		>
			{props.children}
		</div>
	);
}
